export const LIMIT_TO_APP_RELATED_DRIVE_DATA_SCOPE_URL = 'https://www.googleapis.com/auth/drive.file';
export const DRIVE_API_DISCOVERY_DOC_URL = 'https://www.googleapis.com/discovery/v1/apis/drive/v3/rest';